import Vue from 'vue'

const Bus = new Vue()

export default Bus



// WEBPACK FOOTER //
// ./src/js/events/event_bus.js